var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSum = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M24.762 0C25.446 0 26 .554 26 1.238v23.524c0 .684-.554 1.238-1.238 1.238H1.238A1.238 1.238 0 0 1 0 24.762V1.238C0 .554.554 0 1.238 0zM17.34 6H7.964a.5.5 0 0 0-.5.5v1.228a.5.5 0 0 0 .128.335l4.217 4.677a.5.5 0 0 1-.037.706l-.002.002-4.602 4.095a.5.5 0 0 0-.168.373V19.5a.5.5 0 0 0 .5.5h10.634v-1.836a.5.5 0 0 0-.5-.5h-6.392a.5.5 0 0 1-.331-.875l4.234-3.748a.5.5 0 0 0 .04-.709l-3.23-3.577a.5.5 0 0 1 .37-.835h5.016a.5.5 0 0 0 .5-.5V6.5a.5.5 0 0 0-.5-.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSum);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sum.b1ace3f07c39982d85ce79427b938775.svg";